module.exports = __webpack_public_path__ + "Img_Osmium_512px.png";